module.exports = __webpack_public_path__ + "static/img/publish_success.3f7cf166.png";